import { render, staticRenderFns } from "./PcAdvisorUserSettingsNavigationItem.vue?vue&type=template&id=0e42ec7a"
import script from "./PcAdvisorUserSettingsNavigationItem.vue?vue&type=script&lang=js"
export * from "./PcAdvisorUserSettingsNavigationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports